import axios from "axios";
export const LOGO = "https://i.imgur.com/l3iyW8R.png";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = async (path, opts = {}) => {
  const token = localStorage.getItem("mastofa_token");
  const r = await axios({
    url: API + path,
    ...opts,
    headers: {
      ...(opts.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  return r.data;
};

export const rupiah = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");

export const youtubeId = (url = "") => {
  const m =
    url.match(/(?:v=|\/shorts\/|youtu\.be\/)([\w-]{6,})/) ||
    url.match(/embed\/([\w-]{6,})/);
  return m ? m[1] : "";
};

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("mastofa_user") || "{}");
  } catch {
    return {};
  }
};

export const logout = () => {
  localStorage.clear();
  window.location.href = "/";
};
